import { $, $$ } from 'utils/dom';
import Swiperslider from 'modules/swiper/swiper';

const HubEventSlider = $$('.hub-event-teaser');

if (HubEventSlider.length) {
  HubEventSlider.forEach(hubEvent => {
    const slider = new Swiperslider($('.hub-event-teaser__swiper', hubEvent), {
      container: hubEvent,
      sliderOptions: {
        spaceBetween: 30,
        slideToClickedSlide: true,
        allowTouchMove: true,
        breakpoints: {
          768: {
            enabled: false,
            spaceBetween: 0,
          },
        },
      },
    });
    slider.init();
  });
}
